import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
    HiOutlineHome,
    HiOutlineBriefcase,
    HiOutlineChatAlt2,
    HiOutlineCog,
    HiOutlineBell,
    HiOutlineLocationMarker,
} from "react-icons/hi";
import { FaInstagram, FaYoutube, FaCheckCircle } from "react-icons/fa";

// --- Campaign card color palettes ---
const CARD_COLORS = [
    { bg: "from-[#FDDEC8] to-[#FDE8D8]" },   // Peach
    { bg: "from-[#C8F0E0] to-[#D8F5E8]" },   // Mint
    { bg: "from-[#C8DEFF] to-[#D8E8FF]" },   // Blue
    { bg: "from-[#E0C8FF] to-[#ECD8FF]" },   // Lavender
    { bg: "from-[#FFC8D8] to-[#FFD8E4]" },   // Pink
    { bg: "from-[#FFF3C8] to-[#FFF8D8]" },   // Yellow
];

// Placeholder brand logos using coloured circles with initials
const BRAND_LOGOS = [
    { initial: "L", color: "#1A1A1A", text: "white" },   // L'Oreal
    { initial: "A", color: "#0056A0", text: "white" },   // Adidas
    { initial: "P", color: "#D4002A", text: "white" },   // Puma
];

const COMPLETED_CAMPAIGNS = [
    { name: "Name", date: "12-09-24", brand: { initial: "P", color: "#D4002A" }, colorIdx: 0 },
    { name: "Name", date: "12-09-24", brand: { initial: "A", color: "#0056A0" }, colorIdx: 1 },
    { name: "Name", date: "12-09-24", brand: { initial: "L", color: "#1A1A1A" }, colorIdx: 2 },
    { name: "Name", date: "12-09-24", brand: { initial: "P", color: "#D4002A" }, colorIdx: 3 },
    { name: "Name", date: "12-09-24", brand: { initial: "A", color: "#0056A0" }, colorIdx: 4 },
    { name: "Name", date: "12-09-24", brand: { initial: "L", color: "#1A1A1A" }, colorIdx: 5 },
];

const NICHES = [
    { label: "Fashion", emoji: "👗" },
    { label: "Travel", emoji: "🌐" },
    { label: "Beauty", emoji: "🔑" },
];

const CreatorPublicProfile = () => {
    return (
        <div className="flex h-screen bg-[#FDFBF7] overflow-hidden">
            <Sidebar />

            <main className="flex-1 flex flex-col min-w-0 overflow-hidden">
                {/* Header */}
                <header className="px-8 py-4 flex justify-end items-center shrink-0">
                    <div className="flex items-center gap-6">
                        <button className="relative text-gray-500 hover:text-gray-700">
                            <HiOutlineBell className="text-2xl" />
                        </button>
                        <div className="flex items-center gap-3">
                            <span className="text-sm font-bold text-gray-800">Johan Doe</span>
                            <Link
                                to="/creator/public-profile"
                                className="w-10 h-10 rounded-full bg-[#0044CC] flex items-center justify-center text-white font-bold shadow-md hover:ring-2 hover:ring-blue-300 transition-all"
                            >
                                J
                            </Link>
                        </div>
                    </div>
                </header>

                {/* Scrollable content */}
                <div className="flex-1 overflow-y-auto px-8 pb-10">

                    {/* Profile Card */}
                    <div className="bg-[#EEF3FF] rounded-3xl p-8 mb-8">
                        <div className="flex items-start gap-8">
                            {/* Avatar */}
                            <div className="w-36 h-36 rounded-full overflow-hidden shrink-0 shadow-md border-4 border-white">
                                <img
                                    src="https://i.pravatar.cc/150?u=kamran"
                                    alt="Profile"
                                    className="w-full h-full object-cover"
                                />
                            </div>

                            {/* Info */}
                            <div className="flex-1 pt-2">
                                {/* Name + badge */}
                                <div className="flex items-center gap-2 mb-1">
                                    <h1 className="text-3xl font-extrabold text-gray-900">Kamran Razvi</h1>
                                    <FaCheckCircle className="text-blue-500 text-2xl" />
                                </div>

                                {/* Username */}
                                <p className="text-gray-500 text-sm mb-3">kamranrazvii</p>

                                {/* Social Icons */}
                                <div className="flex items-center gap-2 mb-4">
                                    <button className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center text-gray-600 hover:bg-gray-100 transition-colors">
                                        <FaInstagram className="text-base" />
                                    </button>
                                    <button className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center text-gray-600 hover:bg-gray-100 transition-colors">
                                        <FaYoutube className="text-base" />
                                    </button>
                                </div>

                                {/* Location */}
                                <div className="flex items-center gap-1 text-gray-500 text-sm mb-4">
                                    <HiOutlineLocationMarker className="text-base" />
                                    <span>Hyderabad, In.</span>
                                </div>

                                {/* Bio */}
                                <div className="mb-5">
                                    <p className="text-xs font-bold text-gray-500 mb-1">Bio</p>
                                    <p className="text-sm text-gray-700 leading-relaxed max-w-xl">
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                    </p>
                                </div>

                                {/* Bottom row: Niches | Worked with | Campaign Completed */}
                                <div className="flex items-start gap-12 flex-wrap">
                                    {/* Niches */}
                                    <div>
                                        <p className="text-xs font-bold text-gray-500 mb-2">Niches</p>
                                        <div className="flex items-center gap-2 flex-wrap">
                                            {NICHES.map((n) => (
                                                <span
                                                    key={n.label}
                                                    className="flex items-center gap-1 bg-white rounded-full px-3 py-1 text-xs font-bold text-gray-700 shadow-sm border border-gray-100"
                                                >
                                                    <span>{n.emoji}</span> {n.label}
                                                </span>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Worked with */}
                                    <div>
                                        <p className="text-xs font-bold text-gray-500 mb-2">Worked with</p>
                                        <div className="flex -space-x-2">
                                            {BRAND_LOGOS.map((brand, i) => (
                                                <div
                                                    key={i}
                                                    className="w-9 h-9 rounded-full border-2 border-white flex items-center justify-center text-xs font-extrabold shadow-sm"
                                                    style={{ backgroundColor: brand.color, color: brand.text }}
                                                >
                                                    {brand.initial}
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Campaign Completed */}
                                    <div>
                                        <p className="text-xs font-bold text-gray-500 mb-2">Campaign Completed</p>
                                        <p className="text-4xl font-extrabold text-gray-900">10</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Completed Campaign Grid */}
                    <div>
                        <h2 className="text-2xl font-extrabold text-gray-900 mb-5">Campaign Completed</h2>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
                            {COMPLETED_CAMPAIGNS.map((campaign, i) => (
                                <div
                                    key={i}
                                    className={`bg-gradient-to-br ${CARD_COLORS[campaign.colorIdx].bg} rounded-3xl aspect-[3/4] relative overflow-hidden cursor-pointer group hover:scale-[1.02] transition-transform duration-200 shadow-sm`}
                                >
                                    {/* Bottom info bar */}
                                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent px-4 py-3 flex items-end justify-between">
                                        <div>
                                            <p className="text-white font-bold text-sm">{campaign.name}</p>
                                            <p className="text-white/70 text-xs">{campaign.date}</p>
                                        </div>
                                        {/* Brand logo badge */}
                                        <div
                                            className="w-9 h-9 rounded-full border-2 border-white flex items-center justify-center text-xs font-extrabold shadow-md"
                                            style={{ backgroundColor: campaign.brand.color, color: "white" }}
                                        >
                                            {campaign.brand.initial}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

// Sidebar (same pattern as CreatorSettings)
const Sidebar = () => {
    const location = useLocation();
    const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + "/");

    return (
        <aside className="w-64 bg-white border-r border-gray-100 flex flex-col hidden md:flex shrink-0 z-20">
            <div className="p-6 flex items-center gap-2 text-black font-bold text-xl">
                <img src="/logo.png" alt="Braccet" className="w-8 h-8 object-contain" />
                <span>Braccet</span>
            </div>

            <nav className="flex-1 px-4 py-6 space-y-2">
                <SidebarItem icon={<HiOutlineHome />} label="Dashboard" to="/creator/dashboard" active={isActive("/creator/dashboard")} />
                <SidebarItem icon={<HiOutlineBriefcase />} label="Campaigns" to="/creator/find-work" active={isActive("/creator/find-work")} />
                <SidebarItem icon={<span className="font-bold text-lg">(B)</span>} label="Brands" to="/creator/brands" active={isActive("/creator/brands")} />
                <SidebarItem icon={<HiOutlineChatAlt2 />} label="Messages" to="/creator/messages" active={isActive("/creator/messages")} />
                <SidebarItem icon={<HiOutlineCog />} label="Settings" to="/creator/profile" active={isActive("/creator/profile") || isActive("/creator/settings")} />
            </nav>

            <div className="p-4 border-t border-gray-100">
                <button className="flex w-full items-center gap-3 p-2 rounded-xl text-gray-500 font-bold hover:bg-gray-50 hover:text-red-500 transition-colors">
                    <svg className="w-6 h-6 rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                    </svg>
                    Logout
                </button>
            </div>
        </aside>
    );
};

const SidebarItem = ({ icon, label, to, active }) => (
    <Link
        to={to}
        className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors ${active ? "bg-blue-50 text-[#0044CC]" : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"}`}
    >
        <span className="text-xl">{icon}</span>
        {label}
    </Link>
);

export default CreatorPublicProfile;
